"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StartEventViewModel = void 0;
const index_1 = require("../../Model/Events/index");
const EventBaseViewModel_1 = require("./EventBaseViewModel");
class StartEventViewModel extends EventBaseViewModel_1.EventViewModel {
    constructor(startEvent, processModel) {
        var _a, _b, _c;
        super(startEvent, processModel);
        this.timerType = ((_a = startEvent.timerEventDefinition) === null || _a === void 0 ? void 0 : _a.timerType) ?
            index_1.TimerType[(_b = startEvent.timerEventDefinition) === null || _b === void 0 ? void 0 : _b.timerType] : null;
        this.timerValue = (_c = startEvent.timerEventDefinition) === null || _c === void 0 ? void 0 : _c.value;
    }
}
exports.StartEventViewModel = StartEventViewModel;
//# sourceMappingURL=StartEventViewModel.js.map